import { CloseOutlined } from '@ant-design/icons';
import { getModel } from '@smx-ui-model/store-model';
import { GenericModelSchemaType, StoreModelType, TableResourceType } from '@smx-ui-model/types';
import { Button, Flex } from 'antd';
import * as React from 'react';
import { memo, useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { SmxInspectorContext } from './inspector-provider';
import { deleteCurrentModel, setterInspector } from './store/slices/inspector-slice';

interface HeaderInspectorProps {
    modelName: keyof StoreModelType;
    entity?: TableResourceType;
}

const HeaderInspector: React.FC<HeaderInspectorProps> = ({ entity, modelName }) => {
    const dispatch = useDispatch();
    const { isOpen, setIsOpen } = useContext(SmxInspectorContext);

    useEffect(() => {
        if (!isOpen) {
            setTimeout(() => {
                if (entity) {
                    dispatch(deleteCurrentModel(entity.key));
                } else {
                    dispatch(setterInspector({ nameNewEntity: undefined }));
                }
            }, 500);
        }
    }, [isOpen]);

    const handleClose = () => {
        setIsOpen?.(false);
    };

    console.log(modelName);
    const label = (!entity ? 'New ' : '') + getModel<GenericModelSchemaType>(modelName)?.label;

    return (
        <Flex align={'center'} gap={10}>
            <Button onClick={handleClose} type="text" variant={'filled'} icon={<CloseOutlined />} />
            <label style={{ fontSize: 16, fontWeight: 'bold' }}>{label}</label>
        </Flex>
    );
};

export default memo(HeaderInspector);
